import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { withRouter } from 'react-router-dom';

import classNames from 'classnames';

import { Menu } from 'semantic-ui-react';

import '../css/TopNav.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { VIEW_SELECTION } from '../managers/NavigationManager';
import { TOP_NAV_NAME } from '../constants';

import InitService from '../services/InitService';
import PopupService from '../services/PopupService';
import TopNavService from '../services/TopNavService';
import UserService from '../services/UserService';

export default
@inject(
  'appManager',
  'contentManager',
  'ltiManager',
  'navigationManager',
  'topNavManager',
  'userManager')
@observer
class LtiTopNav extends Component {
  constructor(props) {
    super(props);
    this.AriaSkipLink = SatCoreComponent('AriaSkipLink');
    this.LogoButtons = SatCoreComponent('LogoButtons');
    this.ProfileMenu = SatCoreComponent('ProfileMenu');
    this.menuBarRef = React.createRef();
  }

  componentDidMount() {
    const { appManager, history, ltiManager, topNavManager } = this.props;

    topNavManager.setActiveTopNavName(TOP_NAV_NAME.LtiTopNav);
    InitService.initActiveUserRoleAsHtmlBodyAttr();

    // Redirect to first LTI nav tab based on ltiTopNavOrderArray
    if (ltiManager.isLti && !ltiManager.isLtiUnauthorized) {
      const { topNavObj } = TopNavService.getLtiMainTopNavInfo() || {};

      if (topNavObj?.functionKey) {
        const mainTopNavFunction = this[topNavObj.functionKey];
        if (typeof mainTopNavFunction === 'function') {
          mainTopNavFunction();
        }
      }
    }

    this.unlisten = history.listen((location, _action) => {
      appManager.setLocation(location);
    });
  }

  componentWillUnmount() {
    InitService.removeHtmlBodyRoleAttr();
    this.unlisten?.();
  }

  showProfile = () => {
    const { history } = this.props;
    history.push('/profile', { url: history.createHref(history.location) });
  };

  handleClickRoleSwitcher = () => {
    const { history } = this.props;
    UserService.showRoleSwitcher(history);
  };

  handleClickLtiContentPicker = async () => {
    const { history, navigationManager } = this.props;
    navigationManager.setView(VIEW_SELECTION.LTI_CONTENT_PICKER);
    await history.push(`/ltiContentPicker?view=${VIEW_SELECTION.LTI_CONTENT_PICKER}`);
  };

  handleClickTestBuilder = async () => {
    const { history, navigationManager, userManager } = this.props;
    if (userManager.canViewSatelliteTestBuilder) {
      navigationManager.setView(VIEW_SELECTION.TEST_BUILDER);
      await history.push(`/testbuilder?view=${VIEW_SELECTION.TEST_BUILDER}`);
    }
  }

  handleClickReports = async () => {
    const { history, navigationManager } = this.props;
    const noAddDefaultBreadcrumb = true;
    navigationManager.clearAllPaths(noAddDefaultBreadcrumb);
    navigationManager.setView(VIEW_SELECTION.REPORTS);
    await history.push(`/reports?view=${VIEW_SELECTION.REPORTS}`);
  }

  handleLogout = async () => {
    // TODO uncomment if we implement logout functionality for LtiTopNav.
    // At the moment, there is no need for a logout option in the ProfileMen here,
    // since LtiTopNav is expected to run inside a closable iframe.
    //
    // const { history, navigationManager, t, topNavManager } = this.props;
    // const strOfItemsToPreserve = '';
    // const externalLogoutUrlKey = getEnvironmentSpecificTranslationKey('externalLogoutUrl');
    // const externalLogoutUrl = t(externalLogoutUrlKey);
    // InitService.doLogoutCleanUp(strOfItemsToPreserve, { externalLogoutUrl });
    // if (!externalLogoutUrl || !topNavManager.allowLoginRedirectUrl) {
    //   navigationManager.setView(VIEW_SELECTION.LOGIN);
    //   history.replace('/signin');
    // }
  }

  isViewSelected = (view) => {
    const { navigationManager } = this.props;
    const { viewSelection } = navigationManager;
    return viewSelection && viewSelection === view;
  }

  isViewSelectedClass = (view) => (this.isViewSelected(view) ? 'selected' : null);

  renderMenuItem = (children, view, props, {
    _id,
    navTranslationRolloverKey = ''
  } = {}) => {
    const { ltiManager, t } = this.props;

    const rolloverMessage = t(navTranslationRolloverKey);
    const isDisabled = ltiManager.isLtiUnauthorized;

    const tnavTabClassName = classNames(
      'tnav-tab',
      this.isViewSelectedClass(view),
      props?.className,
      { disabled: isDisabled }
    );

    return (
      PopupService.renderPopup({
        content: rolloverMessage,
        disabled: !rolloverMessage,
        key: _id,
        trigger: (
          <Menu.Item
            aria-current={this.isViewSelectedClass(view) ? 'page' : undefined}
            aria-disabled={isDisabled}
            as='li'
            data-nav-item
            disabled={isDisabled}
            role='link'
            tabIndex={isDisabled ? '-1' : '0'}
            {...props}
            className={tnavTabClassName}
            onClick={async (event, _data) => {
              if (!isDisabled) {
                await props.onClick();
              }
            }}>
            {children}
          </Menu.Item>
        ),
        wide: false
      })
    );
  }

  getNavTabs = () => {
    const { t, userManager } = this.props;

    const { canViewSatelliteTestBuilder } = userManager;
    const showTestBuilderTab = canViewSatelliteTestBuilder;

    const {
      USER_TOP_NAV,
      topNavOrderArray
    } = TopNavService.getLtiMainTopNavInfo() || {};

    const tabs = topNavOrderArray?.map?.((tabNavId) => {
      const tabNavObj = USER_TOP_NAV[tabNavId];

      const { _id, className, functionKey, navTranslationKey, viewSelectionKey } = tabNavObj;

      switch (_id) {
        case USER_TOP_NAV.ltiContentPicker?._id:
          break;
        case USER_TOP_NAV.testBuilder?._id:
          if (!showTestBuilderTab) {
            return;
          }
          break;
        case USER_TOP_NAV.reports?._id:
          break;
      }
      return this.renderMenuItem(t(navTranslationKey), VIEW_SELECTION[viewSelectionKey], {
        className, onClick: this[functionKey]
      }, {
        ...(tabNavObj || {})
      });
    }).filter((tabNavObj) => !!tabNavObj);

    return (
      <>
        {tabs}
        {this.getAdditionalTopNavExternalResources()}
      </>
    );
  };

  /**
   * Render LTI top-nav's external resource menu item(s) for each entry in the satellite's
   * `additionalLtiTopNavExternalResources` config.
   *
   * Use `additionalLtiTopNavExternalResources` if configured; otherwise fall back
   * to a single entry built from `contentManager.resourceIFrameUrl` (the default
   * teacher/admin resource link).
   */
  getAdditionalTopNavExternalResources = () => {
    const { contentManager, t, topNavManager } = this.props;

    const defaultTopNavExternalResources = contentManager.resourceIFrameUrl
      ? [{ _id: 'resourceLabelDefault', url: contentManager.resourceIFrameUrl }]
      : [];

    const configuredResources = topNavManager.additionalLtiTopNavExternalResources;
    const hasConfiguredResources = Array.isArray(configuredResources) && configuredResources.length;
    const additionalLtiTopNavExternalResources = hasConfiguredResources
      ? configuredResources
      : defaultTopNavExternalResources;

    if (!additionalLtiTopNavExternalResources.length) {
      return null;
    }

    return additionalLtiTopNavExternalResources.map((resourceUrlObj) => {
      if (typeof resourceUrlObj !== 'object' || !resourceUrlObj?._id) {
        return;
      }

      const className = resourceUrlObj.className || classNames('resources', resourceUrlObj._id);
      const navTranslationKey = resourceUrlObj.navTranslationKey || resourceUrlObj._id;
      const viewSelectionKey = resourceUrlObj.viewSelectionKey || 'resources';

      const handleClickExternalResource = () => {
        const externalResourceUrl = TopNavService.appendTopNavExternalResourceUrlParams(resourceUrlObj);
        if (externalResourceUrl) {
          window.open(externalResourceUrl);
        }
      };

      return this.renderMenuItem(t(navTranslationKey), VIEW_SELECTION[viewSelectionKey], {
        className, onClick: handleClickExternalResource
      }, {
        ...(resourceUrlObj || {}),
        className,
        navTranslationKey,
        viewSelectionKey
      });
    }).filter((obj) => obj);
  }

  renderProfileMenu = () => {
    const { ProfileMenu, props: { profileMenu, t } } = this;

    // NOTE: Profile options are currently hardcoded for now for LtiTopNav.
    // LTI within the satellite typically only needs 'Profile' (no logout since the app runs inside an iframe).
    // We can customize this later if needed by following the pattern in TopNav.renderProfileMenu.
    const options = [{
      className: 'profile',
      onClick: this.showProfile,
      text: t('profile')
    }];

    return (
      <ProfileMenu
        {...profileMenu}
        options={options} />
    );
  }

  render() {
    const { additionalClassName = '', history, location, t } = this.props;
    const { AriaSkipLink, LogoButtons } = this;

    let topNavClassName = 'topNav';
    topNavClassName += additionalClassName ? ` ${additionalClassName}` : '';

    return (
      <Menu
        as={(props) => <header id='top-nav-bar' {...props} ref={this.menuBarRef} />}
        className={topNavClassName}
        fixed='top'
        inverted
        onKeyDown={(e) => TopNavService.topNavHandleKeyDown(e, this.menuBarRef)}>
        <LogoButtons
          history={history}
          location={location}
          navButton />
        <AriaSkipLink mainContentId='main-content' />
        <Menu.Menu
          aria-label={t('navigationPanel')}
          as={(props) => <nav {...props} />}
          position='right'>
          <ul className='nav-list' role='toolbar'>
            {this.getNavTabs()}
          </ul>
          {this.renderProfileMenu()}
        </Menu.Menu>
      </Menu>
    );
  }
}

SatCoreRegister('LtiTopNav', withRouter(LtiTopNav));
